import { ChangeDetectorRef, Component, EventEmitter, HostListener, Output } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { FormBuilder, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ApiHttpService } from 'src/app/core/services/apiHttpcall.service';
import * as moment from 'moment';

@Component({
  selector: 'app-edit-dialog',
  templateUrl: './edit-dialog.component.html',
  styleUrls: ['./edit-dialog.component.scss'],
})
export class EditDialogComponent {
  data: any;
  editForm: any;
  hours_arr: any = this.getHours();
  is_form_submit: boolean = false;
  mins_arr: any = [];
  show_Dialog: boolean = false;
  type: string = ''; // "start" or "complete"

  @Output() dialogSubmit: EventEmitter<any> = new EventEmitter();

  @HostListener('document:keydown.escape', ['$event'])
  onEscPressed(event: KeyboardEvent) {
    this.hide();
  }

  constructor(
    public dialogService: DialogService,
    private fb: FormBuilder,
    private httpService: ApiHttpService,
    private messageService: MessageService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.getMinutes();
  }

  async show() {
    this.initializeForm(); 
    this.show_Dialog = true;
  }
  
  hide() {
    this.show_Dialog = false;
    this.dialogService.dialogComponentRefMap.forEach(dialog => {
        dialog.destroy();
    });
  }

  initializeForm() {
    let type = this.type == 'start' ? 'started' : 'completed';

    // Reset form controls and trigger change detection to avoid stale references 
    this.editForm = null; 
    this.cdr.detectChanges(); 

    this.editForm = this.fb.group({
      [`${this.type}_at`]: [
        this.type === 'start'
          ? (this.data?.actual_started_at ? new Date(this.data.actual_started_at) : null)
          : (this.data?.actual_completed_at ? new Date(this.data.actual_completed_at) : null),
        Validators.compose([Validators.required]),
      ],      
      [`actual_${this.type}_date`]: [null],
      [`actual_${this.type}_time`]: [null],
      [`${this.type}_hr`]: [null, Validators.compose([Validators.required])],
      [`${this.type}_min`]: ['00', Validators.compose([Validators.required])],
    });

    if (this.data?.[`actual_${type}_at`]) {
      this.setTime();
    }
  }

  getMinutes() {
    for (let i = 0; i < 60; i++) {
      this.mins_arr.push({
        id: i.toString().padStart(2, '0'),
        name: `${i.toString().padStart(2, '0')} min`,
      });
    }
  }

  getHours(): any[] {
    return Array.from({ length: 24 }, (_, i) => ({ name: i.toString().padStart(2, '0') }));
  }
  

  setTime() {
    let type = this.type == 'start' ? 'started' : 'completed';
    let time = this.data[`actual_${type}_at`].split(' ')[1];
    this.editForm.controls[`${this.type}_hr`].setValue(time.split(':')[0]);
    this.editForm.controls[`${this.type}_min`].setValue(time.split(':')[1]);
  }

  async submit() {
    if (this.editForm.valid) {
      this.editForm.controls[`actual_${this.type}_time`].setValue(
        `${this.editForm.controls[`${this.type}_hr`].value}:${this.editForm.controls[`${this.type}_min`].value}`
      );
      this.editForm.controls[`actual_${this.type}_date`].setValue(
        moment(this.editForm.controls[`${this.type}_at`].value).format(
          'MM/DD/YYYY'
        )
      );
      delete this.editForm.value[`${this.type}_at`];
      let resp = await this.httpService.post(
        `/trip-detail/${this.data?.id}/update-date`,
        this.editForm.value
      );
      if (resp?.status == 200) {
        this.messageService.add({
          severity: 'customSuccess',
          icon: 'i-check-circle',
          summary: 'Success',
          detail: 'Leg updated successfully',
          key: 'app_notiy',
        });
        this.dialogSubmit.emit();
        this.hide();
      } else {
        this.messageService.add({
          severity: 'error',
          summary: 'Failed',
          detail: resp?.error?.message,
          key: 'app_notiy',
        });
      }
    }
  }
}
